import type { InfiniteData, QueryClient } from '@tanstack/react-query';
import type { SchemaChatResolver_GetMessages } from 'cpool-tables/backend-resolvers';

import { DEFAULT_MESSAGE_PAGE_SIZE } from '~/features/whatsapp/constants';
import { getChatMessagesInfiniteQueryKey } from '~/features/whatsapp/utils/getChatMessagesInfiniteQueryKey';

export const mergeGapMessagesIntoInfiniteCache = (
    queryClient: QueryClient,
    chatId: string,
    gapMessages: SchemaChatResolver_GetMessages,
    limit = DEFAULT_MESSAGE_PAGE_SIZE,
) => {
    if (gapMessages.length === 0) return;

    const queryKey = getChatMessagesInfiniteQueryKey(chatId, limit);
    queryClient.setQueryData<InfiniteData<SchemaChatResolver_GetMessages>>(queryKey, (existing) => {
        if (!existing?.pages.length) return existing;

        const existingIds = new Set(existing.pages.flat().map((message) => message.messageId));
        const newMessages = gapMessages.filter((message) => !existingIds.has(message.messageId));
        if (newMessages.length === 0) return existing;

        const [firstPage, ...olderPages] = existing.pages;
        return {
            ...existing,
            pages: [[...(firstPage ?? []), ...newMessages], ...olderPages],
        };
    });
};
